import { Components } from '@mui/material/styles/components';
import { ControllerMenuColor } from '../../palette';

export const MenuComponent: Components = {
  MuiMenu: {
    styleOverrides: {
      paper: {
        '&.MuiPopover-paper': {
          border: `1px solid ${ControllerMenuColor.Border}`,
          borderRadius: 2,
          boxShadow: `0px 3px 8px rgba(0, 0, 0, 0.15)`,
        },
      },
    },
  },
};
